module.exports = __webpack_public_path__ + "static/media/flower5.91ad47e5.png";